import { render, staticRenderFns } from "./destoryCard.vue?vue&type=template&id=cc6b4640&scoped=true"
import script from "./destoryCard.vue?vue&type=script&lang=js"
export * from "./destoryCard.vue?vue&type=script&lang=js"
import style0 from "./destoryCard.vue?vue&type=style&index=0&id=cc6b4640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6b4640",
  null
  
)

export default component.exports